import numeral from 'numeral';
import { licenseValidators } from '@/globals/functions/licenseValidators';
import { isBuildAvoidanceLicensed, isBuildAvoidanceAgent, isDashboardLicensed } from '@/globals/functions/licenseValidationRules';
import { dialogPresets } from '@/services/dialogPresets';

export const mixin = {
  mixins: [dialogPresets],
  methods: {
    isFeatureOn(featureName) {
      const featureFlag = `VUE_APP_FEATURE_${featureName}`;
      if (process.env.NODE_ENV === 'development') console.info(`Feature ${featureName} is set to ${process.env[featureFlag]}`);
      return process.env[featureFlag];
    },
    resizeChartWidget(i, s, h, w, lh) {
      const that = this;
      const lsLayout = JSON.parse(localStorage.getItem('dashboardLayout')).find(x => x.i === that.i);
      const hComputed = h || lsLayout.h;
      const wComputed = w || lsLayout.w;
      this.$store.dispatch('main/RESIZE_GRID_ITEM', {
        i,
        h: hComputed,
        w: wComputed,
        lh,
      });
    },
    async removeWidget(i) {
      await this.$store.dispatch('main/REMOVE_WIDGET', i).then(() => {
        this.$eventHub.$emit('removeWidget', i);
      });
      this.$eventHub.$emit('checkIfDashboardIsEmpty');
    },
    routerPush(name) {
      if (name !== this.$route.name) {
        this.$router.push({
          name,
        });
      }
    },
    convertToCSV(objArray) {
      const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
      let str = '';
      for (let i = 0; i < array.length; i++) {
        let line = '';
        Object.keys(array[i]).forEach(key => {
          if (Object.prototype.hasOwnProperty.call(array[i], key)) {
            if (line !== '') line += ',';
            line += array[i][key];
          }
        });
        str += `${line}\r\n`;
      }

      return str;
    },

    openDialog(type, data) {
      if (this.$store.getters['main/dialogOpen']) {
        this.$store.commit('main/dialogState', false);
      }
      this.$store.commit('main/openDialog', { component: type, data });
    },
    uniformOrNull(countA, countB) {
      const allA = countA === countB;
      const allB = countA === 0;
      return allA || allB ? allA : null;
    },
    formatNum(num) {
      if (num) {
        if (num > 999) {
          return numeral(num).format('0.0a').toUpperCase();
        }
        return num;
      }
      return 0;
    },
    licenseValidators,
    isBuildAvoidanceLicensed,
    isBuildAvoidanceAgent,
    isDashboardLicensed,
  },
};
